import { KeyValueModel } from '@models/common';

export type PresetDocument = {
  contractIds: number[];
  description: string;
  documentNumber: number;
  entityId: number;
  id: number;
  moduleDocumentNumber: string;
  name: string;
  screenId: string;
  values: unknown[];
  valuesLookup: unknown;
};

export type PresetModule = KeyValueModel<number, string> & {
  count?: number;
  iconId?: number;
  color?: string;
};

export type PresetAllocation = {
  id: number;
  name: string;
  description?: string;
  type?: number;
  typeName?: string;
  moduleDocumentNumber?: string;
  documentNumber?: number;
  documentNoMinor?: number;
  entityId?: number;
  screenId?: number;
  contractIds?: number[];
  isUsed: boolean;
  /** A document was already created from it — the checkbox is locked. */
  isPicked: boolean;
};
